import * as angular from 'angular';

import { DateValue, GetAggregatedValuesDto as AggregatedValuesDto, TableWidgetDto } from '../../models/DTO';
import { IRequestService } from '../request.service';
import * as Enum from '../../models/enum';
import { ResultsStatus } from '../../models/enum';


export interface AggregationRequestParams {
    guid: string;
    objectType: Enum.ObjectType;
    value: string;
    beginDateTime: string;
    endDateTime: string;
    aggregationMode: Enum.AggregationMode;
    aggregationInterval: number;
    aggregationUnit: Enum.TimeUnit;
}

export interface IAggregatedValuesService {
    getAggregatedValues(configuration: AggregationRequestParams): angular.IPromise<DateValue[]>;
    getAggregatedValuesList(configuration: AggregatedValuesDto): angular.IPromise<TableWidgetDto>;
    getStatusBetweenDates(configuration: { guid: string; objectType: number; beginDateTime: string; endDateTime: string }): angular.IPromise<ResultsStatus>;
}

export class AggregatedValuesService implements IAggregatedValuesService {
    private _controllerUrl = 'aggregatedValues';

    static $inject = ['$q', 'requestService'];
    static serviceId = 'aggregatedValuesService';

    constructor(private _$q: angular.IQService,
        private _requestService: IRequestService) {
    }

    getAggregatedValues(configuration: AggregationRequestParams): angular.IPromise<DateValue[]> {
        return this._requestService.getAtV1(this._controllerUrl, configuration);
    }

    getStatusBetweenDates(configuration: { guid: string; objectType: number; beginDateTime: string; endDateTime: string }): angular.IPromise<ResultsStatus> {
        const controllerAction = `${this._controllerUrl}/getStatusBetweenDates`;
        return this._requestService.getAtV1(controllerAction, configuration);
    }

    getAggregatedValuesList(configuration: AggregatedValuesDto): angular.IPromise<TableWidgetDto> {
        const controllerAction = `${this._controllerUrl}/GetAggregatedValuesList`;
        return this._requestService.cachedPostAtV1<TableWidgetDto>(controllerAction, configuration);
    }
}